// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host { display: block; width: 100%; height: 100%; }

    .flex-spacer { flex: 1; }

    /* ─── Mobile header ─── */
    .mobile-header {
      position: fixed;
      top: 0; left: 0; right: 0;
      z-index: 1050;
      background: #fff;
      border-bottom: 1px solid #f0eafa;
      box-shadow: 0 2px 16px rgba(109,40,217,.08);
      /* overflow:visible so ngb dropdowns are NOT clipped */
      overflow: visible;
    }

    .mh-row1 {
      display: flex;
      align-items: center;
      height: 52px;
      padding: 0 1rem;
      gap: .75rem;
    }

    .mh-logo { height: 28px; width: auto; object-fit: contain; }

    .mh-bell {
      display: flex; align-items: center; justify-content: center;
      width: 38px; height: 38px;
      border: 1.5px solid #f0eafa; background: #faf8ff;
      border-radius: 10px; cursor: pointer; color: #7c3aed;
      flex-shrink: 0;
      -webkit-tap-highlight-color: transparent;
    }
    .mh-bell:active { background: #ede9fb; }

    .mh-row2 {
      display: flex;
      align-items: center;
      min-height: 56px;
      padding: .5rem .875rem;
      border-top: 1px solid #f0eafa;
      background: #fdfbff;
      /* overflow:visible so dropdowns escape */
      overflow: visible;
    }

    /* ─── Mobile content shell ───
       header: 52px + 56px = 108px
       bottom nav: 60px                  */
    .mobile-shell {
      position: fixed;
      top: 108px;
      left: 0; right: 0;
      bottom: 60px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .mobile-main {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      background: #f8fafc;
      padding-bottom: 8px;
      -webkit-overflow-scrolling: touch;
    }
    .mobile-main::-webkit-scrollbar { display: none; }
  `, "",{"version":3,"sources":["webpack://./apps/clients-portal/src/app/layouts/default-layout/default-layout.component.ts"],"names":[],"mappings":";IACI,QAAQ,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE;;IAEnD,eAAe,OAAO,EAAE;;IAExB,0BAA0B;IAC1B;MACE,eAAe;MACf,MAAM,EAAE,OAAO,EAAE,QAAQ;MACzB,aAAa;MACb,gBAAgB;MAChB,gCAAgC;MAChC,2CAA2C;MAC3C,sDAAsD;MACtD,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,eAAe;MACf,WAAW;IACb;;IAEA,WAAW,YAAY,EAAE,WAAW,EAAE,mBAAmB,EAAE;;IAE3D;MACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;MAC3D,WAAW,EAAE,YAAY;MACzB,2BAA2B,EAAE,mBAAmB;MAChD,mBAAmB,EAAE,eAAe,EAAE,cAAc;MACpD,cAAc;MACd,wCAAwC;IAC1C;IACA,kBAAkB,mBAAmB,EAAE;;IAEvC;MACE,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,sBAAsB;MACtB,6BAA6B;MAC7B,mBAAmB;MACnB,yCAAyC;MACzC,iBAAiB;IACnB;;IAEA;;0CAEsC;IACtC;MACE,eAAe;MACf,UAAU;MACV,OAAO,EAAE,QAAQ;MACjB,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,OAAO;MACP,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;MACnB,iCAAiC;IACnC;IACA,kCAAkC,aAAa,EAAE","sourcesContent":["\n    :host { display: block; width: 100%; height: 100%; }\n\n    .flex-spacer { flex: 1; }\n\n    /* ─── Mobile header ─── */\n    .mobile-header {\n      position: fixed;\n      top: 0; left: 0; right: 0;\n      z-index: 1050;\n      background: #fff;\n      border-bottom: 1px solid #f0eafa;\n      box-shadow: 0 2px 16px rgba(109,40,217,.08);\n      /* overflow:visible so ngb dropdowns are NOT clipped */\n      overflow: visible;\n    }\n\n    .mh-row1 {\n      display: flex;\n      align-items: center;\n      height: 52px;\n      padding: 0 1rem;\n      gap: .75rem;\n    }\n\n    .mh-logo { height: 28px; width: auto; object-fit: contain; }\n\n    .mh-bell {\n      display: flex; align-items: center; justify-content: center;\n      width: 38px; height: 38px;\n      border: 1.5px solid #f0eafa; background: #faf8ff;\n      border-radius: 10px; cursor: pointer; color: #7c3aed;\n      flex-shrink: 0;\n      -webkit-tap-highlight-color: transparent;\n    }\n    .mh-bell:active { background: #ede9fb; }\n\n    .mh-row2 {\n      display: flex;\n      align-items: center;\n      min-height: 56px;\n      padding: .5rem .875rem;\n      border-top: 1px solid #f0eafa;\n      background: #fdfbff;\n      /* overflow:visible so dropdowns escape */\n      overflow: visible;\n    }\n\n    /* ─── Mobile content shell ───\n       header: 52px + 56px = 108px\n       bottom nav: 60px                  */\n    .mobile-shell {\n      position: fixed;\n      top: 108px;\n      left: 0; right: 0;\n      bottom: 60px;\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n    }\n\n    .mobile-main {\n      flex: 1;\n      overflow-y: auto;\n      overflow-x: hidden;\n      background: #f8fafc;\n      padding-bottom: 8px;\n      -webkit-overflow-scrolling: touch;\n    }\n    .mobile-main::-webkit-scrollbar { display: none; }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
